export default "__VITE_ASSET__ZWGKq0Yy__"